export default function LogoutIcon({ className = "cursor-pointer" }: { className?: string }) {
  return (
    <svg className={className} width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M2.33398 13.9993L1.74833 13.5308L1.37352 13.9993L1.74833 14.4679L2.33398 13.9993ZM12.834 14.7493C13.2482 14.7493 13.584 14.4136 13.584 13.9993C13.584 13.5851 13.2482 13.2493 12.834 13.2493V14.7493ZM6.415 7.69749L1.74833 13.5308L2.91964 14.4679L7.5863 8.63454L6.415 7.69749ZM1.74833 14.4679L6.415 20.3012L7.5863 19.3642L2.91964 13.5308L1.74833 14.4679ZM2.33398 14.7493H12.834V13.2493H2.33398V14.7493Z"
        fill="currentColor"
      />
      <path
        d="M11.666 9.48791V8.05583C11.666 6.43748 11.666 5.62831 12.14 5.06882C12.6139 4.50933 13.4121 4.3763 15.0084 4.11025L18.6796 3.49838C21.9227 2.95787 23.5443 2.68761 24.6051 3.58631C25.666 4.485 25.666 6.12892 25.666 9.41675V18.5846C25.666 21.8724 25.666 23.5163 24.6051 24.415C23.5443 25.3137 21.9227 25.0434 18.6796 24.5029L15.0084 23.8911C13.4121 23.625 12.6139 23.492 12.14 22.9325C11.666 22.373 11.666 21.5638 11.666 19.9455V18.7443"
        stroke="currentColor"
        strokeWidth="1.5"
      />
    </svg>
  );
}
